// src/utils/ItemCardClickedAnalytics.js
export const trackButtonClick = (item_inhouse_code, item_number, item_color_en) => {
 if (typeof gtag === "function") {
  gtag("event", "click", {
   event_category: "Item Card Clicked",
   event_label: `${item_number} ${item_color_en} ${item_inhouse_code}`,
  });
  //   console.log("Item Card Clicked:", `${item_number} ${item_color_en} ${item_inhouse_code}`);
 } else {
  console.warn("gtag function is not available");
 }
};
